<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div
      class="spinner"
      v-show="isDelayed"
    >
      <div class="spin"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('api', ['isDelayed']),
  }
}
</script>


<style lang="scss">
.spinner {
  position: fixed;
  z-index: 99999;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
  .spin {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50px;
    height: 50px;
    animation: spin 0.8s infinite linear;
    background: url(../../assets/images/img_spinner.png) no-repeat 0 0;
    background-size: 50px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



